import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DiscoverTeaser } from '@zero/discover/domain';
import { DiscoverSlidePipe } from '../../utils/pipes/discover-slide.pipe';
import { DiscoverPagingComponent } from '../discover-paging/discover-paging.component';

@Component({
  selector: 'discover-latest',
  templateUrl: './discover-latest.component.html',
  styleUrls: ['./discover-latest.component.scss'],
  imports: [DiscoverSlidePipe, DiscoverPagingComponent],
})
export class DiscoverLatestComponent {
  public slide = 1;
  public readonly itemsPerSlide = 3;

  @Input() public teasers: DiscoverTeaser[];

  @Output() public openDetails = new EventEmitter<string>();
}
